module.exports = __webpack_public_path__ + "static/img/12.5c8c8a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/12.png
// module id = CF/H
// module chunks = 0